import React, { FC, HTMLAttributes, useState } from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { createUseStyles } from 'src/theming';
import CreateTicketDialog from '../../components/CreateTicketDialog';
import { LegacyDeal } from 'src/interfaces/api/Deal';
import { CreateTicketOptions } from 'src/interfaces/api/Ticket';
import StatusSelect from './components/StatusSelect';
import Legend from './components/Legend';
import { DomainSelect } from 'src/components/ApiField';
import DealTable from './components/DealTable';

const useStyles = createUseStyles({
  table: {
    overflowX: 'auto',
  },
});

interface Props extends HTMLAttributes<HTMLDivElement> {
  deals: LegacyDeal[];
  loading: boolean;
  siteId?: string;
  style?: any;
  onCreateTicket: (ticketOptions: CreateTicketOptions) => void;
}

const DealsSection: FC<Props> = ({ loading, onCreateTicket, hidden, siteId, deals, style }) => {
  const [createTicketForDealId, setCreateTicketForDealId] = useState<number>();
  const [domainFilter, setDomainFilter] = useState<number>();
  const [showCustomerSatisfaction, setShowCustomerSatisfaction] = useState(false);
  const [status, setStatus] = useState<string>();
  const classes = useStyles();

  const handleShowCustomerSatisfaction = (event) => {
    setShowCustomerSatisfaction(event.target.checked);
  };

  const handleChangeStatus = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const newStatus = event.target.value as string;
    setStatus(newStatus);
  };

  const handleDomainFilterChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const newDomain = parseInt(event.target.value as string, 10);
    setDomainFilter(newDomain);
  };

  if (loading) {
    return <Skeleton />;
  }

  return (
    <div style={style} hidden={hidden}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent='flex-end'>
            <Grid item xs={12}>
              <Grid container spacing={2} justifyContent='space-between'>
                <Grid item>
                  <Legend />
                </Grid>

                <Grid item>
                  {/*<Button onClick={() => setCreateDealModalOpen(true)} variant='contained' color='primary'>*/}
                  {/*  <AddIcon size={20} />*/}
                  {/*</Button>*/}
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <DomainSelect size='small' onChange={handleDomainFilterChange} useLegacyId value={domainFilter} />
            </Grid>

            <Grid item>
              <StatusSelect size='small' value={status} onChange={handleChangeStatus} />
            </Grid>

            <Grid item>
              <FormControlLabel
                style={{ marginBottom: 0 }}
                control={<Checkbox checked={showCustomerSatisfaction} onChange={handleShowCustomerSatisfaction} />}
                label='Filtrer par avis clients'
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className={classes.table}>
          <DealTable
            deals={deals}
            siteId={siteId}
            domainFilter={domainFilter}
            statusFilter={status}
            showCustomerSatisfaction={showCustomerSatisfaction}
            onCreateTicket={setCreateTicketForDealId}
          />
        </Grid>
      </Grid>

      {siteId && (
        <CreateTicketDialog
          siteId={siteId}
          onValidate={onCreateTicket}
          legacyDealId={createTicketForDealId}
          open={!!createTicketForDealId}
          onClose={() => setCreateTicketForDealId(undefined)}
        />
      )}
    </div>
  );
};

export default DealsSection;
